import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af9aa8dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-panel" }
const _hoisted_2 = { key: 0 }


export default /*#__PURE__*/_defineComponent({
  __name: 'group-fieldset-component',
  props: {
  /**
   * The title or heading associated with the component.
   * @type {string}
   * @required
   */
  title: {
    type: String,
    default: undefined,
  },
  /**
   * Whether the layout is column or row.
   * @type {string}
   * @default 'column'
   */
  layout: {
    type: String,
    default: "column",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("legend", _hoisted_2, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["panel-content", `layout-${__props.layout}`])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})